/* ============================================================================
   TCK — Cart drawer quantity vs Fastrr "BUY NOW" race fix
   Paste this INSIDE the same inline <script> that defines cartChange()
   (cart drawer snippet, near line ~3040), AFTER cartChange is defined.
   ----------------------------------------------------------------------------
   Problem it fixes:
   - Tapping +/- updates the number on screen instantly, but POST /cart/change.js
     takes ~0.9s-1.6s (measured up to 8s) on this store.
   - Until it lands, GET /cart.js still returns the OLD quantity.
   - The theme only disables .cart-item__qty-btn during that window; the Fastrr
     BUY NOW button stays clickable, so checkout gets built from the stale cart
     => "qty 3 daala, order me 1 hi aaya".
   - Fastrr's button carries disabled=true in the DOM but is click-handled by a
     delegated listener on an ancestor, so setting .disabled is NOT enough.
     We must intercept the click in the CAPTURE phase.
   ========================================================================== */
(function () {
  'use strict';

  var BUY_SELECTOR = 'form.buy-buttons, .buy-buttons, [name="checkout"], .cart-drawer__checkout, a[href^="/checkout"]';

  window.__cartBusy = 0;
  var pendingClick = null;

  /* ---------- 1. visual "cart syncing" state ------------------------------ */
  function paintBusy(on) {
    document.querySelectorAll(BUY_SELECTOR).forEach(function (el) {
      el.classList.toggle('cart-syncing', !!on);
      el.setAttribute('aria-busy', on ? 'true' : 'false');
      el.style.opacity = on ? '0.55' : '';
      el.style.pointerEvents = on ? 'none' : '';   // blocks delegated handlers too
    });
  }

  /* ---------- 2. public busy counter -------------------------------------- */
  window.cartBusyStart = function () {
    window.__cartBusy++;
    paintBusy(true);
  };

  window.cartBusyEnd = function () {
    window.__cartBusy = Math.max(0, window.__cartBusy - 1);
    if (window.__cartBusy === 0) {
      paintBusy(false);
      if (pendingClick) {
        var el = pendingClick;
        pendingClick = null;
        // cart is now in sync — replay the checkout click the user already made
        setTimeout(function () { el.click(); }, 0);
      }
    }
  };

  /* ---------- 3. capture-phase guard on the checkout button --------------- */
  document.addEventListener('click', function (e) {
    if (window.__cartBusy <= 0) return;
    var btn = e.target.closest && e.target.closest(BUY_SELECTOR);
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    pendingClick = e.target.closest('button, a') || btn;
  }, true);   // <-- true = capture, runs before Fastrr's listener

  /* ---------- 4. wrap cartChange so every update flips the flag ----------- */
  if (typeof window.cartChange === 'function' && !window.cartChange.__wrapped) {
    var original = window.cartChange;
    var wrapped = function (target, newQty, onSuccess, onFail) {
      window.cartBusyStart();
      var settled = false;
      var done = function () { if (!settled) { settled = true; window.cartBusyEnd(); } };
      return original(
        target,
        newQty,
        function (cartData) { done(); if (onSuccess) onSuccess(cartData); },
        function (err)      { done(); if (onFail)    onFail(err); }
      );
    };
    wrapped.__wrapped = true;
    window.cartChange = wrapped;
  }

  /* ---------- 5. last-line-of-defence: verify before checkout ------------- */
  /* Reads the real cart one final time and repairs any drift using line KEYS
     (not line indexes) before handing over to Fastrr.                        */
  window.verifyCartBeforeCheckout = function () {
    var rows = document.querySelectorAll('.cart-item[data-line-key], [data-key].cart-item');
    var want = {};
    rows.forEach(function (row) {
      var key = row.getAttribute('data-line-key') || row.getAttribute('data-key');
      var inp = row.querySelector('.quantity-input');
      if (key && inp) want[key] = parseInt(inp.value, 10) || 0;
    });
    return fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        var drift = false;
        cart.items.forEach(function (it) {
          if (want[it.key] !== undefined && want[it.key] !== it.quantity) {
            updates[it.key] = want[it.key];
            drift = true;
          }
        });
        if (!drift) return cart;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) { return r.json(); });
      });
  };

  /* ---------- 6. stop the /cart.js pollers from caching a stale cart ------ */
  /* forceCartCount(), cart-delivery-picker.js recalc() and the chat widget all
     poll /cart.js. Skip them while an update is in flight.                   */
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartRead = /\/cart\.js/.test(url) && (!init || !init.method || init.method.toUpperCase() === 'GET');
    if (isCartRead && window.__cartBusy > 0) {
      // defer the read until the write has landed
      return new Promise(function (resolve) {
        var tries = 0;
        (function wait() {
          if (window.__cartBusy <= 0 || ++tries > 60) {
            resolve(nativeFetch.call(window, input, init));
          } else {
            setTimeout(wait, 100);
          }
        })();
      });
    }
    return nativeFetch.call(window, input, init);
  };
})();
